<template>
    <div class="or-service-card anim-scale hover-pointer" @click="()=> {options.redirect === 'feedback' ? $emit('to-feedback') : changePage({page: 'buyers'})}">
        <img class="image" :src="require(`../../../../assets/${options.image}.jpg`)" alt="img"/>
        <p class="title">{{options.title}}</p>
        <p class="text">{{options.text[0]}}<br/>{{options.text[1]}}</p>
        <div class="button flex-row flex-center anim-services-card">
            <img class="icon" src="../../../../assets/services_icon.svg"/>
            <p class="button-text">Заказать</p>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    props: {
        options: Object,
    },
    methods: {
        ...mapActions({changePage: 'changePage'}),
    }
}
</script>

<style scoped>
    .or-service-card {
        position: relative;
        width: 350px;
        height: 504px;
        background-color: #1E1E1E;
        border-radius: 8px;
        overflow: hidden;
    }
    .image {
        margin-bottom: 15px;
    }
    .title {
        font-size: 24px;
        line-height: 29px;
        text-align: center;
        color: #FFFFFF;
        margin-bottom: 10px;
    }
    .text {
        font-size: 14px;
        line-height: 25px;
        text-align: center;
        color: #EBB932;
    }
    .button {
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        background-color: #EBB932;
        width: 100%;
        height: 86px;
        color: #000000;
    }
    .icon {
        margin-right: 27px;
    }
    .button-text {
        font-size: 30px;
        line-height: 36px;
        text-align: center;
    }
</style>